import { useThaloWeb } from "@/contexts/ThaloWebContext";
import { ThaloDataTable } from "@/components/thalo-data-table";
import React, { useState } from "react";
import useInstallationMetrics from "@/metrics/useInstallationMetrics";
import { ColumnDef, Row } from "@tanstack/react-table";
import { Card } from "@/components/ui/card";
import {
  getInitialColumnVisibility,
  InstallationWithMetrics,
  METRICS
} from "./installationMetrics";
import { MetricValueCell } from "@/metrics/MetricValueCell";
import { useDateRange } from "@/dateRanges/DateRangeContext";
import { TODAY } from "@/dateRanges/dateRanges";

const metricColumn = (metricName: string, metricHumanReadable: string): ColumnDef<InstallationWithMetrics> => ({
  id: metricName,
  accessorFn: (installationWithMetrics: InstallationWithMetrics) => installationWithMetrics.metrics.find((metric: any) => metric.name = metricName)?.value,
  header: metricHumanReadable,
  cell: ({ row }: { row: Row<InstallationWithMetrics> }) => <MetricValueCell row={row} metricName={metricName}/>,
});

const METRICS_TABLE_COLUMNS: ColumnDef<InstallationWithMetrics>[] = [
  {
    id: "location__name",
    accessorFn: (row) => row.location.name,
    header: "Location",
    cell: ({ row }) => {
      return (
        <div className="flex flex-col">
          <div className="lg:text-lg truncate text-ellipsis">
            {row.original.location.name}
          </div>
        </div>
      );
    },
    meta: {
      className: "",
    },
  },
  {
    id: "name",
    accessorFn: (row) => row.name,
    header: "Asset",
    cell: ({ row }) => {
      return (
        <div className="flex flex-col">
          <div className="lg:text-lg truncate text-ellipsis">
            {row.original.name}
          </div>
        </div>
      );
    },
    meta: {
      className: "",
    },
  },
  ...METRICS.map(({ id, name }) => metricColumn(id, name)),
];

const MetricsTable = () => {
  const { selectedOrganization } = useThaloWeb();

  const { dateRange } = useDateRange({ overrideDefaultDateRange: TODAY });

  const [filter, setFilter] = useState('')

  const {
    installationMetrics,
    sorting,
    setSorting,
    pagination,
    setPagination
  } = useInstallationMetrics(selectedOrganization?.id, dateRange, filter)

  const initialColumnVisibility = getInitialColumnVisibility();

  return (
    <Card className="px-4">
      <ThaloDataTable
        variant="thalo"
        data={installationMetrics.data?.results}
        columns={METRICS_TABLE_COLUMNS}
        isLoading={installationMetrics.isPending}
        itemsPerPage={pagination.pageSize}
        onPaginationChange={setPagination}
        sorting={sorting}
        onSortingChange={setSorting}
        onFilterChange={setFilter}
        pagination={pagination}
        pageCount={Math.ceil(
          installationMetrics.data?.count! / installationMetrics.data?.page_size!
        )}
        initialColumnVisibility={initialColumnVisibility}
      />
    </Card>
  )
}

export default MetricsTable;
